export default __webpack_public_path__ + "media/images/logo-f0551db3177dc33ef0b4f29a4b5088a7.png";